import { createRoute, redirect } from '@tanstack/react-router'
import { lazy } from 'react'
import { Notice, Page } from '../../ui'
import { useOrg } from '../org'
import type { LazyPage } from './lazy-page'
import { guardAt } from './products'
import { rootRoute } from './root'

const ZmanimPage: LazyPage = lazy(() =>
  import('../../routes/ZmanimPage').then((m) => ({ default: m.ZmanimPage })),
)
const RulesSection: LazyPage<{ spaceId: string }> = lazy(() =>
  import('../../routes/settings/RulesSection').then((m) => ({
    default: m.RulesSection,
  })),
)
/** The Rules view of the Schedule home — the same section the settings page used. */
function RulesPage() {
  const { spaceId } = useOrg()
  return (
    <Page>
      {spaceId ? (
        <RulesSection spaceId={spaceId} />
      ) : (
        <Notice tone="error">No congregation selected.</Notice>
      )}
    </Page>
  )
}
const zmanimRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/zmanim',
  beforeLoad: guardAt('/zmanim'),
  component: ZmanimPage,
})
// Rules is a view of the Schedule home now, not a settings sub-page.
const rulesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/rules',
  beforeLoad: guardAt('/rules'),
  component: RulesPage,
})
/* The old name remains as redirects only; code identifiers remain `modaah`. */
const legacyModaahRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notices',
  beforeLoad: () => {
    guardAt('/notices')()
    throw redirect({ to: '/pages' })
  },
})
const legacyModaahNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notices/new',
  beforeLoad: () => {
    guardAt('/notices')()
    throw redirect({ to: '/pages/new' })
  },
})
const legacyModaahEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notices/$id',
  beforeLoad: ({ params }) => {
    guardAt('/notices')()
    throw redirect({ to: '/pages/$key', params: { key: params.id } })
  },
})

export const luachRoutes = [
  zmanimRoute,
  rulesRoute,
  legacyModaahRoute,
  legacyModaahNewRoute,
  legacyModaahEditRoute,
]
